import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // 페이지 이동을 위해 useNavigate 사용
import axios from "axios";
import { Chip } from "../../../assets/components/Chip";
import { SelectBoxB } from "../../../assets/components/SelectGroup";
import down_tri from "../../../assets/icons/Arrow/down_tri.svg";
import up_tri from "../../../assets/icons/Arrow/up_tri.svg";
import down_circle from "../../../assets/icons/System/circle_down_primary.svg";
import up_circle from "../../../assets/icons/System/circle_up_primary.svg";

const FaqList = ({ faqList, setFaqList, type, storeBusinessNumber }) => {
    const navigate = useNavigate(); // useNavigate 훅 사용
    const [selectedCategory, setSelectedCategory] = useState("전체");
    const [openIndex, setOpenIndex] = useState(null);
    const [isCategoryOpen, setIsCategoryOpen] = useState(false);

    // 내가 원하는 카테고리 순서 그대로 정의
    const CATEGORY_ORDER = ["전체", "회원가입", "소셜 채널 업로드", "AI 마케팅 이미지 생성", "광고 예약", "마이페이지"];

    // 카테고리 목록 추출
    const categories = (() => {
        const raw = [
            "전체",
            ...new Set(faqList.map((faq) => faq.category_name)),
        ];

        // 중복 제거
        const unique = [...new Set(raw)];

        // CATEGORY_ORDER 기준으로 정렬
        return unique.sort((a, b) => {
            const ia = CATEGORY_ORDER.indexOf(a);
            const ib = CATEGORY_ORDER.indexOf(b);

            const sa = ia === -1 ? Number.MAX_SAFE_INTEGER : ia;
            const sb = ib === -1 ? Number.MAX_SAFE_INTEGER : ib;

            return sa - sb;
        });
    })();

    // 필터링된 FAQ
    const filteredFaqs =
        selectedCategory === "전체"
            ? faqList
            : faqList.filter((faq) => faq.category_name === selectedCategory);

    const toggleAnswer = (index) => {
        setOpenIndex((prev) => (prev === index ? null : index));
    };

    const handleEdit = (faq) => {
        navigate("/ads/faq/create", {
            state: {
                storeBusinessNumber: storeBusinessNumber,
                type: type,
                faq: faq,
            },
        }); // '/ads/notice/create' 경로로 이동
    };

    const handleDelete = async (faq_id) => {
        if (!window.confirm("정말 삭제하시겠습니까?")) return;

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_FASTAPI_ADS_URL}/faq/delete`,
                { faq_id }, // ✅ 삭제할 ID 전송
                { headers: { "Content-Type": "application/json" } }
            );
            if (response.status === 201) {
                setFaqList((prevList) =>
                    prevList.filter((faq) => faq.faq_id !== faq_id)
                );
            } else {
                alert("FAQ 삭제 실패");
            }
        } catch (error) {
            console.error("FAQ 삭제 실패:", error);
            alert("삭제 중 오류가 발생했습니다.");
        }
    };

    return (
        <div className="flex flex-col h-dvh bg-surface-default">
            {/* 카테고리 필터 버튼 */}
            <div className="flex flex-col items-center gap-[8px]">
                <div className="px-[16px] pt-[24px] pb-[16px] relative w-full">
                    <div className={"flex flex-wrap justify-start gap-[12px] pr-[40px] "+
                        (isCategoryOpen ? "max-h-[120px] overflow-y-auto" : "max-h-[32px] overflow-hidden")}>
                        {categories.map((cat) => (
                            <Chip
                                chip="d"
                                key={cat}
                                label={cat}
                                status={selectedCategory === cat ? "selected" : "default"}
                                onClick={() => setSelectedCategory(cat)}
                                className="min-w-0 w-auto"
                            >
                                {cat}
                            </Chip>
                        ))}
                    </div>
                    {categories.length > 3 && (
                        <button
                            type="button"
                            onClick={() => setIsCategoryOpen((prev) => !prev)}
                            className="py-[24px] absolute right-0 top-[2px] p-0 inline-flex items-center justify-center shrink-0"
                        >
                            <img
                                src={isCategoryOpen ? up_circle : down_circle}
                                alt="카테고리 펼치기/접기"
                                className="w-[28px] h-[28px]"
                            />
                        </button>
                    )}
                </div>

                <div className="mb-[12px] w-full h-[16px] bg-surface-light-subtle"></div>
            </div>

            {/* <div className="h-[18px] bg-surface-light-subtle"></div> */}

            {/* FAQ 목록 */}
            <div className="px-[16px] pb-[32px]">
                {filteredFaqs.length === 0 ? (
                    <div className="text-center text-gray-500 py-6">
                        FAQ가 없습니다.
                    </div>
                ) : (
                    filteredFaqs.map((faq, index) => (
                        <div key={faq.faq_id} className="gap-[8px]">
                            <div className="text-c2 text-text-subtler pt-[12px]">
                                {faq.category_name}
                            </div>
                            <div className="pt-[8px]">
                                <SelectBoxB
                                    title={faq.question}
                                    onClick={() => toggleAnswer(index)}
                                    rightIcon={
                                        <img
                                            src={
                                                openIndex === index
                                                    ? up_tri
                                                    : down_tri
                                            }
                                            alt="업 다운"
                                        />
                                    }
                                />
                            </div>
                            {/* <div
                                className="bg-surface-light-white flex justify-between items-center cursor-pointer"                                
                                onClick={() => toggleAnswer(index)}
                            >
                                                             
                                <div className="font-medium">{faq.question}</div>
                                <span className="text-xl">
                                    {/* {openIndex === index ? '−' : '+'} *
                                    <img src={openIndex === index ? up : down} alt="닫기 : 열기" />
                                </span> 
                            </div> */}
                            {openIndex === index && (
                                // <div className="pt-2 bg-gray-100 text-gray-700 text-sm border-t">
                                <div className="w-full text-left bg-surface-light-white pt-[12px]">
                                    <div className="rounded-[12px] px-[16px] py-[12px] border-border-default border-[1px]">
                                        <p className="whitespace-pre-line text-c2 text-text-subtler">
                                            {faq.answer}
                                        </p>
                                        {type === "admin" && (
                                            <div className="flex gap-2 justify-end pt-4">
                                                <button
                                                    className="px-3 py-1 bg-yellow-400 text-white text-sm rounded hover:bg-yellow-500"
                                                    onClick={() =>
                                                        handleEdit(faq)
                                                    }
                                                >
                                                    수정
                                                </button>
                                                <button
                                                    className="px-3 py-1 bg-red-500 text-white text-sm rounded hover:bg-red-600"
                                                    onClick={() =>
                                                        handleDelete(faq.faq_id)
                                                    }
                                                >
                                                    삭제
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default FaqList;
